/**
 * Mixdown export: encode an AudioBuffer to WAV and trigger download.
 */
import { audioBufferToWav } from './projectSerializer';

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function encodeAudioBufferToWavBlob(buffer) {
  return new Blob([audioBufferToWav(buffer)], { type: 'audio/wav' });
}
